import type { ReactNode } from 'react';

import { OnboardingFeatureKey } from '@gokrew/models/company';
import { ModuleGuard } from '@/components/ModuleGuard';

/**
 * Performance routes follow the company's module switch (performance spec
 * PF-21): a bookmarked URL goes back to the dashboard while it is off.
 */
export function PerformanceGuard({ children }: { children: ReactNode }) {
  return (
    <ModuleGuard module={OnboardingFeatureKey.Performance}>
      {children}
    </ModuleGuard>
  );
}
